import { render, staticRenderFns } from "./CardSpotlightEvent.vue?vue&type=template&id=4a704a39&"
import script from "./CardSpotlightEvent.vue?vue&type=script&lang=js&"
export * from "./CardSpotlightEvent.vue?vue&type=script&lang=js&"
import style0 from "./CardSpotlightEvent.vue?vue&type=style&index=0&id=4a704a39&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports